export function Spinner({ size = 'sm' }: { size?: 'sm' | 'md' }) {
  const dim = size === 'sm' ? 'h-3 w-3 border-2' : 'h-4 w-4 border-2';
  return (
    <span
      aria-hidden
      className={`inline-block ${dim} rounded-full border-white/40 border-t-white animate-spin`}
    />
  );
}
